import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface IProps {
  isHeader?: boolean;
  children: ReactNode;
}

export function GridRow({ isHeader, children }: IProps) {
  return (
    <Box
      className={`grid-row ${isHeader ? 'grid-row-header' : ''}`}
      sx={{
        display: 'contents',
      }}
    >
      {children}
    </Box>
  );
}
